import React from "react";

import { useMsal } from "@azure/msal-react";
import { clearStorage } from "../utils/storageUtils";
import { useLocation } from "react-router-dom";

function Header({ setRefresh, isClose = false }) {

    const location = useLocation();

    const { instance } = useMsal();

    function onClickRefresh() {
        setRefresh((prev) => {
            return !prev
        });
    }

    function onClickClose() {
        window.close();
    }

    function onClickLogOut() {
        const activeAccount = instance.getActiveAccount();
        clearStorage(activeAccount);

        instance.logoutPopup({
            postLogoutRedirectUri: "/",
            mainWindowRedirectUri: "/"
        })
    }

    return (
        <nav className="flex flex-row justify-between items-center p-2">
            <div className="hover:bg-gray-400" onClick={onClickRefresh}>
                Refresh
            </div>
            <div className="font-bold text-2xl">
                {location.pathname?.includes('/mesga') ? 'MES-GA' :
                    location.pathname?.includes('/bsa1') ? 'MES-BSA 1': 'MES'}
            </div>
            {isClose ? (
                <div className="hover:bg-gray-400" onClick={onClickClose}>
                    Close
                </div>
            ) : (
                <div className="hover:bg-gray-400" onClick={onClickLogOut}>
                    Logout
                </div>
            )}
        </nav>
    );
}

export default Header